/**
 * Alert severity badge with color mapping.
 */

import { Badge } from "@/components/ui/badge";
import type { AlertSeverity } from "@/types/metrics";
import { cn } from "@/lib/utils";

type SeverityBadgeProps = {
  severity: AlertSeverity;
  className?: string;
};

const severityStyles: Record<AlertSeverity, string> = {
  info: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300 border-blue-200 dark:border-blue-800",
  warn: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300 border-yellow-200 dark:border-yellow-800",
  critical:
    "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300 border-red-200 dark:border-red-800",
};

export function SeverityBadge({ severity, className }: SeverityBadgeProps) {
  return (
    <Badge variant="outline" className={cn(severityStyles[severity], className)}>
      {severity}
    </Badge>
  );
}
